import { render, staticRenderFns } from "./FormPrincipalOther.vue?vue&type=template&id=3d72d9f9"
import script from "./FormPrincipalOther.vue?vue&type=script&lang=js"
export * from "./FormPrincipalOther.vue?vue&type=script&lang=js"
import style0 from "./FormPrincipalOther.vue?vue&type=style&index=0&id=3d72d9f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports